import React, { useRef, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {FormControl, Grid, IconButton, Link, TextField, Tooltip} from '@mui/material'
import { FaCopy } from 'react-icons/fa';
import { useClipboard } from 'use-clipboard-copy';

interface CardProps {
  nombre: string;
  cargo: string;
  email?: string;
}

export const SimpleCard: React.FC<CardProps> = ({ nombre, cargo, email = ""}) => {
  const clipboard = useClipboard({
    copiedTimeout: 2000, // timeout duration in milliseconds
  });
  
  return (
    <Card>
      <CardContent>
        <Typography variant="h5" component="div">
          {nombre}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {cargo}
        </Typography>
        {email !== "" 
        ?
          <>
          <Grid container spacing={2}>
          <Grid item xs={10}>
            <FormControl fullWidth>
              <TextField
                id="text1"
                inputRef={clipboard.target}
                label="Contacto"
                variant="outlined"
                fullWidth
                size='small'
                value={email}
              />
            </FormControl>
          </Grid>
          <Grid item xs={2}>
            <Tooltip title={clipboard.copied ? 'Copiado' : 'Copiar al Portapapeles'} arrow>
              <IconButton className="btn1" onClick={clipboard.copy}>
                  <FaCopy />
              </IconButton>
            </Tooltip>  
          </Grid>
        </Grid> 
        </>
        :
          <></>}
      </CardContent>
    </Card>
  );
};